import { Component } from '@angular/core';

@Component({
  selector: 'loading-spinner',
  template: ` <img src="" alt="loader" class="loading" /> `,
  styleUrls: ['loading-spinner.component.scss']
})
export class LoadingSpinnerComponent {}
